import { render } from "./V3StyleBottom.vue?vue&type=template&id=2bf69c15&scoped=true"
import script from "./V3StyleBottom.vue?vue&type=script&lang=js"
export * from "./V3StyleBottom.vue?vue&type=script&lang=js"

import "./V3StyleBottom.vue?vue&type=style&index=0&id=2bf69c15&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf69c15"]])

export default __exports__